/*
  1. Dolly /Tractors can be adhoc (i.e provided by contractors) in that case the user
  can select "/DOLLY" for dolly & "/POWER" for tractors.
  2. TRAILER_NUMBER=/BOB for bobtail flow

*/
const constants = {
  ADHOC_DOLLY: "/DOLLY",
  TRAILER_NUMBER_FOR_BOBTAIL: "/BOB",
  ERROR_MESSAGES: {
    REQUIRED:"* Required",
    DUPLICATE_TRAILER:"Duplicate trailer",
    DUPLICATE_DOLLY:"Duplicate dolly",
    VALID_DRIVER_STATUS: "Driver unavailable for dispatch",
    DRIVER_CLOCKED_IN_STATUS : "Driver not clocked-in",
    DISPATCH_DRIVER_EVENT_FAILED: "Failed to dispatch driver",
    DRIVER_DISPATCHED: "Driver already dispatched",
    STRAIGHT_TRUCK_REQUIRED: "Straight truck is required",
  },
  RMAX_EMPTY_TRAILER_CODE: "MTY", //for different clients rmaxCode will be "MTY" but status can be different, check in getClientCode api
  RMAX_CLOSED_TRAILER_CODE: "CLO", // same for all clients: trailer is closed
  ROUTE_NAME_SUFFIX_LENGTH: 3,
  ROUTE_NAME_MAX_LENGTH: 50,
  ROUTE_NAME_DEFAULT: 'DEFAULTROUTE', // Backend placeholder; do not add to route options
  TRAILER_PARKING_TYPE: {
    D: 'Door',
    A: 'Yard',
  },
  ODOMETER_CONSTANTS : {
    MIN_READING_DIFFERENCE: 2,
    MAX_READING_DIFFERENCE: 600,
    MAX_READING: [9999998, 9999999],
  },
}

export default constants;